import { supabase } from '../supabaseClient';

/* Accès aux données « affectations ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchAssignments() {
  return supabase.from('affectations').select('*').order('id');
}

export function deleteAssignment(aff) {
  return supabase.from('affectations').delete().eq('id', aff.id);
}

export function setAssignmentStart(aff, nextIso) {
  return supabase.from('affectations').update({ debut: nextIso }).eq('id', aff.id);
}

export function setAssignmentEnd(aff, prevIso) {
  return supabase.from('affectations').update({ fin: prevIso }).eq('id', aff.id);
}

export function insertAssignmentRemainder(aff, newId, nextIso, origFin) {
  return supabase.from('affectations').insert({
    id: newId,
    dev_id: aff.devId,
    brique_id: aff.briqueId,
    debut: nextIso,
    fin: origFin,
    heures_par_jour: aff.heuresParJour,
  });
}

export function setAssignmentDate(affId, field, newIso) {
  return supabase
    .from('affectations')
    .update({ [field]: newIso })
    .eq('id', affId);
}

export function insertAssignments(rows) {
  return supabase.from('affectations').insert(rows);
}

// row : { id, dev_id, brique_id, debut, fin, heures_par_jour }
export function insertAssignment(row) {
  return supabase.from('affectations').insert(row);
}

export function deleteAssignmentsByBricks(phBriqueIds) {
  return supabase.from('affectations').delete().in('brique_id', phBriqueIds);
}

export function deleteAssignmentsByBrick(b) {
  return supabase.from('affectations').delete().eq('brique_id', b.id);
}

export function deleteClientAssignments(allAffBriqueIds) {
  return supabase.from('affectations').delete().in('brique_id', allAffBriqueIds);
}

export function upsertAssignments(a) {
  return supabase.from('affectations').upsert({
    id: a.id,
    dev_id: a.devId,
    brique_id: a.briqueId,
    debut: a.debut,
    fin: a.fin,
    heures_par_jour: a.heuresParJour || 7,
  });
}
